<template>
	<div class="header-left_line">
		<div class="title">
			<slot name="title"></slot>
		</div>
	</div>
</template>

<script lang="js">
export default {
  name: 'LeftLineHeader'
}
</script>
<style lang='scss' scoped>
@import '@/assets/styles/components/table.scss';
</style>
